import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, IconButton, Spacing } from 'seagull';
import { Column, Row } from 'seagull/components/Layout';
import { Toast } from 'seagull/components/Toast';
import { Typography } from 'seagull/components/Typography';
import { CloseCross } from 'seagull/icons/essentials';
import { getTestIds } from 'seagull/utils/TestIds';
export const GetPersistentToastContentTID = (parentTestId)=>getTestIds(parentTestId);
export function PersistentToastContent(props) {
    const { type, message, description, action, closeLabel, closeBiName, testId, onClose } = props;
    const { PersistentToastContentTID } = GetPersistentToastContentTID(testId);
    const inner = /*#__PURE__*/ _jsxs(Row, {
        gap: 16,
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                gap: 12,
                alignItems: "center",
                children: [
                    description == null ? /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        children: message
                    }) : /*#__PURE__*/ _jsxs(Column, {
                        gap: Spacing.Space2,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph2",
                                children: message
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph3",
                                skin: "secondary",
                                testId: PersistentToastContentTID.Description(),
                                children: description
                            })
                        ]
                    }),
                    action != null && /*#__PURE__*/ _jsx(Button, {
                        skin: "monochrome",
                        size: "small",
                        bi: {
                            name: action.biName
                        },
                        testId: PersistentToastContentTID.Action(),
                        onClick: action.onAction,
                        children: action.actionLabel
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                bi: {
                    name: closeBiName
                },
                skin: "transparent",
                size: "small",
                tooltip: {
                    title: closeLabel
                },
                testId: PersistentToastContentTID.Close(),
                onClick: onClose,
                children: /*#__PURE__*/ _jsx(CloseCross, {
                    size: 16
                })
            })
        ]
    });
    return /*#__PURE__*/ _jsx(Toast, {
        type: type,
        text: inner,
        testId: testId
    });
}
